"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * IMPORTANT: Do not rename, move, or delete this file.
 * It is used by webpack with a hardcoded file reference!
 *
 * Use this components as a placeholder if you need an import and that import is used only in some targets.
 * Example: Webpack uses this file as a fallback if DrupalRubrics isn't available in target.
 */
var NullComponent = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(NullComponent, _React$PureComponent);

  var _super = _createSuper(NullComponent);

  function NullComponent() {
    (0, _classCallCheck2["default"])(this, NullComponent);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(NullComponent, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return NullComponent;
}(_react["default"].PureComponent);

exports["default"] = NullComponent;